import React from 'react';
import { Modal, ModalBody } from '../ui/index';
import type { LostContractFormProps } from './LostContractForm';
import LostContractForm from './LostContractForm';
import type { ModalWithResultProps } from '../hooks/useModalWithResult';

export type LostContractModalParams = Omit<
  LostContractFormProps,
  'onCancel' | 'onComplete'
>;

export type LostContractModalResult = boolean;

export type LostContractModalProps = ModalWithResultProps<
  LostContractModalResult,
  LostContractModalParams
>;

const LostContractModal = (
  props: LostContractModalProps,
): JSX.Element | null => {
  const { onCancel } = props;
  return (
    <Modal isOpen={true} onClose={onCancel} height="30em" width="30em">
      <ModalBody p={0} overflowX="visible" overflowY="visible">
        <LostContractForm {...props} />
      </ModalBody>
    </Modal>
  );
};

export default LostContractModal;
